
<component
  :is="tag"
  class="icon"
  :class="computedClasses"
  aria-label="icon"
/>
